if (!customElements.get('custom-featured-arrows')) {
  customElements.define(
    'custom-featured-arrows',
    class CustomFeaturedArrows extends HTMLElement {
      connectedCallback() {
        this.carousel = this.parentElement.querySelector('featured-collection');
        this.previousButton = this.querySelector('[name="previous"]');
        this.nextButton = this.querySelector('[name="next"]');
        if (!this.carousel || !this.previousButton || !this.nextButton) return;

        this.mobileQuery = window.matchMedia('(max-width: 767.98px)');
        this.scheduleUpdate = () => {
          if (this.updateFrame) return;
          this.updateFrame = requestAnimationFrame(() => {
            this.updateFrame = null;
            this.updateControls();
          });
        };
        this.onClick = this.handleClick.bind(this);
        this.addEventListener('click', this.onClick);
        this.carousel.addEventListener('scroll', this.scheduleUpdate, { passive: true });
        this.carousel.addEventListener('load', this.scheduleUpdate, true);
        this.mobileQuery.addEventListener('change', this.scheduleUpdate);

        this.resizeObserver = new ResizeObserver(this.scheduleUpdate);
        this.resizeObserver.observe(this.carousel);
        const media = this.carousel.querySelector('.product-card__image-wrapper');
        if (media) this.resizeObserver.observe(media);
        this.scheduleUpdate();
      }

      disconnectedCallback() {
        if (this.updateFrame) cancelAnimationFrame(this.updateFrame);
        this.updateFrame = null;
        this.resizeObserver?.disconnect();
        this.removeEventListener('click', this.onClick);
        this.carousel?.removeEventListener('scroll', this.scheduleUpdate);
        this.carousel?.removeEventListener('load', this.scheduleUpdate, true);
        this.mobileQuery?.removeEventListener('change', this.scheduleUpdate);
      }

      handleClick(event) {
        // Desktop navigation stays with the existing Swiper instance.
        if (!this.mobileQuery.matches || this.dataset.enableMobile !== 'true') return;
        const button = event.target.closest('button');
        if (!button || !this.contains(button) || button.disabled) return;
        event.preventDefault();

        const cards = this.carousel.querySelector('.featured-collection__items')?.children;
        const first = cards?.[0];
        if (!first) return;
        const step = cards[1]
          ? Math.abs(cards[1].offsetLeft - first.offsetLeft)
          : first.getBoundingClientRect().width;
        const direction = getComputedStyle(this.carousel).direction === 'rtl' ? -1 : 1;
        const advance = button.name === 'next' ? 1 : -1;
        this.carousel.scrollBy({
          left: (step || first.getBoundingClientRect().width) * direction * advance,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      }

      updateControls() {
        const media = this.carousel.querySelector('.product-card__image-wrapper');
        if (media && media.getBoundingClientRect().height > 0) {
          const mediaRect = media.getBoundingClientRect();
          const parentRect = this.parentElement.getBoundingClientRect();
          this.style.setProperty(
            '--custom-featured-arrows-top',
            `${mediaRect.top - parentRect.top + mediaRect.height / 2}px`
          );
        }

        if (this.mobileQuery.matches) {
          const maxScroll = Math.max(0, this.carousel.scrollWidth - this.carousel.clientWidth);
          const position = Math.abs(this.carousel.scrollLeft);
          this.hidden = this.dataset.enableMobile !== 'true' || maxScroll <= 1;
          this.previousButton.disabled = position <= 1;
          this.nextButton.disabled = position >= maxScroll - 1;
        } else {
          this.hidden = this.dataset.enableDesktop !== 'true';
          this.previousButton.disabled = false;
          this.nextButton.disabled = false;
        }
      }
    }
  );
}
